import { Component } from '@angular/core';

@Component({
  selector: 'app-customer-review-banner',
  templateUrl: './customer-review-banner.component.html',
  styleUrls: ['./customer-review-banner.component.css']
})
export class CustomerReviewBannerComponent {

  resultarr = [
    {
      heading: "India's only trusted partner for GENERATIONS",
      name: 'Mr. Pawan Kumar',
      location: 'Rajasthan',
      description: 'Mera naam Pawan Kumar hai aur main Rajasthan se be…e liye upyogi aur saarthak saabit hui. Dhanyawaad',
      show_home_page: "",
      showactiveclass: 1,
      testomonial_images: {
        image_1: "https://image.bajajcapitalone.com/bajajcapital/Mr.%20Pawan%20Kumar_0.png"
      }
    },
    {
      heading: "India's only trusted partner for GENERATIONS",
      name: 'Mr. Rahul Jain',
      location: 'Gurgaon',
      description: 'I have been investing through BajajCapital for 5 y… available to help and great post-sales services.',
      show_home_page: "",
      showactiveclass: 2,
      testomonial_images: {
        image_1: "https://image.bajajcapitalone.com/bajajcapital/image%20%289%29%20%281%29.png"
      }
    },
    {
      heading: "India's only trusted partner for GENERATIONS",
      name: 'Mr S.P Verma',
      location: 'Delhi',
      description: 'I would like to share my experience with Bajaj Ca… Website and giving us freedom to invest. Cheers.',
      show_home_page: "",
      showactiveclass: 3,
      testomonial_images: {
        image_1: "https://image.bajajcapitalone.com/bajajcapital/image%20%289%29%20%281%29.png"
      }
    },
    {
      heading: "India's only trusted partner for GENERATIONS",
      name: 'Girish Dev Kulkarni',
      location: 'Mumbai',
      description: "I and my family's wealth have practically grown wi…ed with them digitally.\r\nThank you for this bond!",
      show_home_page: "1",
      showactiveclass: false,
      testomonial_images: {
        image_1: "https://image.bajajcapitalone.com/bajajcapital/1st.png"
      }
    },
    {
      heading: "India's only trusted partner for GENERATIONS",
      name: 'Dr. Rajesh A',
      location: 'Haryana',
      description: 'Congrats Bajaj Capital for launching the new websi…gratulations and best wishes on this new venture.',
      show_home_page: "",
      showactiveclass: 4,
      testomonial_images: {
        image_1: "https://image.bajajcapitalone.com/bajajcapital/Dr.%20Abrol.png"
      }
    }
  ];

}
